import Vue from "vue";
import VueRouter from "vue-router";
import DefaultLayout from '@/layout/index.vue'

Vue.use(VueRouter);

const routes = [
    {
      path: '/',
      component: DefaultLayout,
      children: [
          {
              path: "/",
              name: "jsonPage",
              component: () => import("../views/json/jsonPage.vue"),
              meta: { title: 'json格式化', noAuth: true }
          },
          {
              path: "/encode",
              name: "encode",
              component: () => import("@/views/code/codePage.vue"),
              meta: { title: '编码', noAuth: true }
          },
          {
              path: "/time",
              name: "time",
              component: () => import("@/views/time/timePage.vue"),
              meta: { title: '时间戳', noAuth: true }
          },
          {
              path: "/sign",
              name: "sign",
              component: () => import("@/views/sign/signPage.vue"),
              meta: { title: '手写板', noAuth: true }
          },
          {
              path: "/birthday",
              name: "birthday",
              component: () => import("@/views/birthday/birthdayPage.vue"),
              meta: { title: '生日计算', noAuth: true }
          }
      ]
    }
];

const router = new VueRouter({
    mode: 'hash',
    // mode: 'history',
    scrollBehavior: () => ({ y: 0 }),
    routes
});

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => {
        if (err.name !== 'NavigationDuplicated') throw err;
    });
};

// router.beforeEach((to, from, next) => {
//     next()
// })
export default router;
